import Heading from 'components/Luxkit/Typography/Heading'
import React, { useContext } from 'react'
import { WHY_BOOK_WITH_US_CONTENT } from './constants'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { connect } from 'react-redux'
import ContactContext from 'contexts/contactContext'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'

const StyledLayoutContainer = styled(LayoutContainer)`
  display: flex;
  flex-direction: column;
  gap: ${rem(40)};
  padding: ${rem(40)} 0 ${rem(40)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} ${rem(16)} ${rem(40)} ${rem(16)};
  }

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(40)} unset ${rem(40)} unset;
  }
`

const TileContainer = styled.div`
  display: flex;
  gap: ${rem(12)};
  width: 70vw;

  ${mediaQueryUp.tablet} {
    flex-direction: column;
    width: unset;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: ${rem(24)};
  column-gap: ${rem(16)};
  grid-auto-flow: column;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ${mediaQueryUp.tablet} {
    gap: ${rem(24)};
    grid-auto-flow: row;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }

  ${mediaQueryUp.largeDesktop} {
    gap: ${rem(24)};
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
`

interface Props {
  regionCode: string;
}

function WhyBookWithUsSection(props: Props) {
  const { regionCode } = props
  const geoContact = useContext(ContactContext)

  return (
    <Pane>
      <StyledLayoutContainer>
        <Heading variant="heading2">Why book with Luxury Escapes?</Heading>
        <GridContainer>
          {WHY_BOOK_WITH_US_CONTENT.map((content) => {
            const {
              Icon,
              heading: propsHeading,
              body: propsBody,
              link,
            } = content
            let heading = propsHeading ?? ''
            let body = propsBody ?? ''
            const isCustomerServiceItem = heading === '24/7 customer service'
            const linkText = isCustomerServiceItem ? geoContact.local.humanReadable : link?.text ?? undefined
            const linkHref = isCustomerServiceItem ? `tel:${geoContact.local.number}` : link?.href

            // Override support tile for India
            if (isCustomerServiceItem && NO_24_7_SUPPORT_REGIONS.includes(regionCode)) {
              heading = 'Customer Support'
              body = 'Available seven days a week from 9am to 9pm, ensuring support when you need it most.'
            }

            return (
              <TileContainer key={heading}>
                {Icon}
                <Group direction="vertical" gap={12}>
                  <Group direction="vertical" gap={4}>
                    <BodyText variant="medium" weight="bold">
                      {heading}
                    </BodyText>
                    <BodyText variant="medium">
                      {body}
                    </BodyText>
                  </Group>
                  {linkText && (
                    <TextLink to={link?.to} href={linkHref} size="small" weight="bold" target="_blank">
                      {linkText}
                    </TextLink>
                  )}
                </Group>
              </TileContainer>
            ) })}
        </GridContainer>
      </StyledLayoutContainer>
    </Pane>
  )
}

function mapStateToProps(state: App.State) {
  return {
    regionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(WhyBookWithUsSection)
